import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ShoppingCart03 = function ShoppingCart03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.0001 14H18.136c1.0128 0 1.5192 0 1.9223-.1888a2 2 0 0 0 .8581-.768c.2322-.3799.2881-.8832.4-1.8898l.585-5.265c.0342-.3075.0512-.4612.0018-.5802a.5.5 0 0 0-.2201-.246C21.5702 5 21.4155 5 21.1062 5H4.5002M2 2h1.2484c.2647 0 .397 0 .5005.0503a.5.5 0 0 1 .2165.2035c.0567.1001.065.2322.0815.4963l.9062 14.4998c.0165.2641.0248.3962.0815.4963a.5.5 0 0 0 .2165.2035C5.3546 18 5.487 18 5.7516 18H19M7.5 21.5h.01m8.99 0h.01M8 21.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m9 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 21.5"
    })
  }));
};
export default ShoppingCart03;